import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { createPopper } from "@popperjs/core";

const CustomDropdown = ({
  filteredFields = [],
  addFilter = () => {},
  getColumnLabel = (field) => field,
  triggerIcon,
  noSearch = false,
  dropdownBg = "bg-white",
  dropdownHover = "hover:bg-gray-100",
  onOpen = () => {},
  onClose = () => {},
}) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);
  const popperInstance = useRef(null);

  useEffect(() => {
    if (open && triggerRef.current && dropdownRef.current) {
      popperInstance.current = createPopper(triggerRef.current, dropdownRef.current, {
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "preventOverflow", options: { boundary: "viewport" } },
          { name: "flip", options: { fallbackPlacements: ["bottom-end", "top-start"] } },
        ],
      });
    }

    return () => {
      if (popperInstance.current) {
        popperInstance.current.destroy();
        popperInstance.current = null;
      }
    };
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    open ? onOpen() : onClose();
  }, [open]);

  return (
    <>
      <div className="relative inline-block">
        <div
          ref={triggerRef}
          onClick={() => setOpen(!open)}
          className="cursor-pointer"
        >
          {triggerIcon}
        </div>
      </div>

      {open &&
        ReactDOM.createPortal(
          <div
            ref={dropdownRef}
            className={`z-[9999] min-w-max max-h-64 overflow-auto border rounded shadow-md ${dropdownBg}`}
          >
            <ul className="text-sm text-gray-700">
              {filteredFields.map((field, idx) => {
                const label = getColumnLabel(
                  typeof field === "string" ? field : field.Field
                );
                return (
                  <li
                    key={idx}
                    onClick={() => {
                      addFilter(field);
                      setOpen(false);
                    }}
                    className={`px-3 py-2 cursor-pointer ${dropdownHover}`}
                  >
                    {label}
                  </li>
                );
              })}
            </ul>
          </div>,
          document.body
        )}
    </>
  );
};

export default CustomDropdown;
